var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponentField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30046 1.7887C9.75293 1.62594 10.2477 1.62594 10.7035 1.7887L16.9535 4.02177C17.7803 4.31799 18.3337 5.1025 18.3337 5.98466V13.8883C18.3337 14.7672 17.7803 15.555 16.9502 15.8512L10.7002 18.0843C10.2477 18.247 9.75293 18.247 9.2972 18.0843L3.0472 15.8512C2.22038 15.555 1.66699 14.7705 1.66699 13.8883V5.98466C1.66699 5.10575 2.22038 4.31799 3.05046 4.02177L9.30046 1.7887ZM10.0003 3.75159L4.34603 5.76982L10.0003 7.78805L15.6546 5.76982L10.0003 3.75159ZM11.042 15.7503L16.2503 13.8916V7.77177L11.042 9.63049V15.7503Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentField);
export default __webpack_public_path__ + "static/media/component-field.351b4f1d7d9f789891526ec67ee0b88d.svg";
export { ForwardRef as ReactComponent };